import strToRegExp from './strToRegExp';
const isVerticalNavExclusionRoute = (currentPath, exclusionRoutes) => {
  if (!currentPath) return false;
  for (const exclusionRoute of exclusionRoutes) {
    const regExp = strToRegExp(exclusionRoute);
    if (regExp && regExp.test(currentPath)) {
      return true;
    }
  }
  return false;
};
export default isVerticalNavExclusionRoute;